export default __webpack_public_path__ + "static/media/screen-proffy.c0f0074c.png";